module.exports = __webpack_public_path__ + "static/media/cashIcon.516576ba.svg";